import React from "react";
import { Paper } from "@material-ui/core";
import * as S from '../formStyle';
import DatePicker, { registerLocale } from "react-datepicker";
import * as Style from '../styles'

function DateTimeBox({
    title,
    filterName,
    handleDateChange,
    valoresRespostas,
    isLoading,
    dateFormat,
    ordem,
    conteudoOnChange,
    disabledList,
    componenteWidth
}) {
  const classes = S.useStyles();

  return (
    <>
        <label className={classes.label}>{title}</label>
        <Paper className={classes.mediumDate} style={{ 
            borderBottomLeftRadius: '0px',
            borderBottomRightRadius: '0px',
            cursor: 'auto',
            width: `${componenteWidth}px`,
        }} elevation={0}>
            <Style.DateDiv>
                <DatePicker
                    selected={valoresRespostas[ordem]}
                    name={filterName}
                    disabled={isLoading || disabledList[ordem]}
                    onChange={(date) => {
                        console.log(date)
                        handleDateChange(ordem, date, conteudoOnChange)
                    }}
                    onChangeRaw={(e) => {
                        let valueToFormat = e.target.value
                        if(valueToFormat) {
                            valueToFormat = valueToFormat.slice(0, valueToFormat.lenght < 16  ? valueToFormat.lenght : 16)
                            valueToFormat = valueToFormat.replaceAll('-', '')
                            valueToFormat = valueToFormat.replaceAll('/', '-')
                            valueToFormat = valueToFormat.replaceAll(/[^\d-: ]/g, '')
                            valueToFormat = valueToFormat.replaceAll('-', '/')
                            e.target.value = valueToFormat
                        }
                    }}
                    dateFormat={dateFormat}
                    locale='ptBR'
                    style={{ cursor: 'default' }}
                    timeIntervals={60}
                    showTimeSelect
                    className={classes.inputDate}
                />
            </Style.DateDiv>
        </Paper>
    </>
  );
}

export default DateTimeBox;
